export default "__VITE_ASSET__CPryKkmM__"